var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.setFormClass }, [
    _c("input", {
      attrs: {
        type: "radio",
        id: _vm.radioId,
        name: _vm.name,
        disabled: _vm.disabled
      },
      domProps: { value: _vm.value, checked: _vm.checked },
      on: {
        change: function($event) {
          return _vm.$emit("change", _vm.value)
        }
      }
    }),
    _vm._v(" "),
    _c("label", { attrs: { for: _vm.radioId } }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43fa5281", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43fa5281","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/control/radio/Radio.vue
// module id = null
// module chunks = 